import keyBy from 'lodash/keyBy'
import filter from 'lodash/filter'

import { GET_PHENOMENA_TYPES_SUCCESS } from './actionTypes'

const initialState = {}

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case GET_PHENOMENA_TYPES_SUCCESS:
            return keyBy(filter(payload, o => o.id), 'id')
        default:
            return state
    }
}
